// extracted by mini-css-extract-plugin
export default {"objects":"TotalObjects_objects__JrzlZ","button":"TotalObjects_button__tLBBU","orange":"TotalObjects_orange__QsWOx","blue":"TotalObjects_blue__5wWkr"};